<div mat-dialog-title>
	{{ (isEdit ? "protocols.notes.dialog.title.edit" : "protocols.notes.dialog.title.create") | translate }}
</div>
<div mat-dialog-content>
	<div class="flex flex-col">
		@if (selectedText) {
			<mat-form-field appearance="outline">
				<mat-label>{{ "protocols.notes.dialog.selection" | translate }}</mat-label>
				<textarea
					matInput
					rows="3"
					readonly
					[value]="selectedText"></textarea>
				<mat-icon matIconPrefix>label</mat-icon>
			</mat-form-field>
		} @else {
			<div class="note-no-selection">
				<mat-icon aria-hidden="true">highlight_alt</mat-icon>
				<div class="note-no-selection-text">
					<span class="note-no-selection-title">
						{{ "protocols.notes.dialog.selection.none" | translate }}
					</span>
					<span class="note-no-selection-hint">
						{{ "protocols.notes.dialog.selection.none.hint" | translate }}
					</span>
				</div>
			</div>
		}

		<mat-form-field appearance="outline">
			<mat-label>{{ "protocols.notes.dialog.content" | translate }}</mat-label>
			<textarea
				matInput
				rows="6"
				cdkFocusInitial
				[maxlength]="maxLength"
				[(ngModel)]="content"></textarea>
			<mat-icon matIconPrefix>sticky_note_2</mat-icon>
			<mat-hint [class.note-hint-error]="isTooLong">{{ length }} / {{ maxLength }}</mat-hint>
		</mat-form-field>
	</div>
</div>
<div
	mat-dialog-actions
	[align]="'end'">
	<button
		mat-button
		mat-dialog-close>
		{{ "core.cancel" | translate }}
	</button>
	@if (isLoading) {
		<mat-spinner diameter="40" />
	} @else {
		<button
			mat-raised-button
			color="primary"
			[disabled]="!isReady"
			(click)="save()">
			{{ (isEdit ? "core.save" : "core.create") | translate }}
		</button>
	}
</div>
